import { render } from "./ObjectTypeLinks.vue?vue&type=template&id=5ef45b00"
import script from "./ObjectTypeLinks.vue?vue&type=script&lang=js"
export * from "./ObjectTypeLinks.vue?vue&type=script&lang=js"

import "./ObjectTypeLinks.vue?vue&type=style&index=0&id=5ef45b00&lang=scss"

import exportComponent from "/app/tmp/alangray/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__